import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout, PageHeader } from 'antd'
import InsurancesTable from './tables/InsurancesTable'
import ShabanTable from './tables/ShabanTable'
import DuplicatesTable from './tables/DuplicatesTable'
import MissingTable from './tables/MissingTable'
import OverlapsTable from './tables/OverlapsTable'
import { siteContent, insuranceCalculator, hmoCost, auth } from '@services/api'
import Clarification from '../../components/Popup/Clarification'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class InsuranceCalculator extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            sets: [],
            drugs: '',
            mainInsuranceCases: [],
            filteredMainInsuranceCases: [],
            fitleredMainInsuranceCasesShaban: [],
            shaban: {},
            shabanComparisons: {},
            hmoPrices: [],
            hmoCompanies: {
                '125': 'כללית',
                '132': 'מכבי',
                '135': 'לאומית',
                '142': 'משרד הביטחון',
                '143': 'מאוחדת'
            }
        }
    }

    async componentDidMount() {
        await this.props.insuranceCalculatorStore.createReport(
            this.props.computedMatch.params.id,
            this.props.location.search.split('=').pop()
        )
        await this.updateInsuranceCalculator()
        await this.props.companiesStore.getCompanies()
        await siteContent
            .getSiteContent()
            .then(res => {
                this.setState({
                    sets: JSON.parse(res.data.find(component => component.component === 'sets_').keys)
                })
                this.setState({ drugs: JSON.parse(res.data.content[0].keys).drugs })
            })
            .catch(err => console.log(err))
    }

    updateInsuranceCalculator = async () => {
        const { insuranceCases, person_id } = this.props.insuranceCalculatorStore
        const { hmoCompanies } = this.state
        let policyNumbers = {}
        const mainInsuranceCases = insuranceCases
            .filter(insurance => {
                if (insurance.policy_id && ['GROUP', 'PRIVATE'].find(type => type == insurance.policy_type)) {
                    if (
                        !policyNumbers[insurance.company_id] ||
                        !policyNumbers[insurance.company_id].find(type => type == insurance.policy_type)
                    ) {
                        policyNumbers[insurance.company_id]
                            ? policyNumbers[insurance.company_id].push(insurance.policy_type)
                            : (policyNumbers[insurance.company_id] = [insurance.policy_type])
                        return insurance
                    }
                }
            })
            .map(insurance => {
                if (policyNumbers[insurance.company_id].length > 1) {
                    return {
                        name: `${insurance.company_name
                            .split(' ')
                            .filter(name => name != 'חברה' && name != 'לביטוח')
                            .join(' ')} ${insurance.policy_type === 'GROUP' ? `קבוצתי` : ''}`,
                        company_id: insurance.company_id,
                        policy_type: insurance.policy_type,
                        price: insuranceCases
                            .filter(
                                ins =>
                                    ins.policy_id &&
                                    insurance.company_id == ins.company_id &&
                                    ins.policy_type == insurance.policy_type
                            )
                            .reduce((acc, curr) => acc + curr.policy_price, 0)
                    }
                } else {
                    return {
                        name: insurance.company_name
                            .split(' ')
                            .filter(name => name != 'חברה' && name != 'לביטוח')
                            .join(' '),
                        company_id: insurance.company_id,
                        policy_type: insurance.policy_type,
                        price: insuranceCases
                            .filter(
                                ins =>
                                    ins.policy_id &&
                                    insurance.company_id == ins.company_id &&
                                    ins.policy_type == insurance.policy_type
                            )
                            .reduce((acc, curr) => acc + curr.policy_price, 0)
                    }
                }
            })
        const sets = this.props.insuranceCalculatorStore.newKefelHeser.sets
        const filteredMainInsuranceCases = mainInsuranceCases.filter(insurance => {
            let approve = false
            Object.entries(sets)
                .filter(
                    ([key, value]) =>
                        key != 9 &&
                        key != 14 &&
                        key != 19 &&
                        value.policies.filter(policy => !hmoCompanies[policy.company_id]).length > 1
                )
                .map(([key, value]) => {
                    if (
                        insuranceCases.find(
                            ins =>
                                ins.policy_type === insurance.policy_type &&
                                ins.right_param_set_id == key &&
                                ins.company_id == insurance.company_id
                        )
                    ) {
                        approve = true
                    }
                })
            return approve
        })
        const fitleredMainInsuranceCasesShaban = mainInsuranceCases.filter(insurance => {
            let approve = false
            Object.entries(sets)
                .filter(
                    ([key, value]) =>
                        key != 9 &&
                        key != 14 &&
                        key != 19 &&
                        value.policies.length > 1 &&
                        value.policies.find(policy => hmoCompanies[policy.company_id])
                )
                .map(([key, value]) => {
                    if (
                        insuranceCases.find(
                            ins =>
                                ins.policy_type === insurance.policy_type &&
                                ins.right_param_set_id == key &&
                                ins.company_id == insurance.company_id
                        )
                    ) {
                        approve = true
                    }
                })

            return approve
        })

        const shaban = insuranceCases.find(
            insurance => insurance.policy_id && 'SHABAN' === insurance.policy_type && hmoCompanies[insurance.company_id]
        )
        const user = (await auth.getInfo(person_id)).data
        const shabanComparisons = (await insuranceCalculator.shabanComparisons()).data
        const hmoPrices = Object.values((await hmoCost.getHmoComp([user])).data).flat()
        this.setState({
            mainInsuranceCases,
            filteredMainInsuranceCases,
            fitleredMainInsuranceCasesShaban,
            shaban,
            shabanComparisons,
            hmoPrices
        })
    }

    goBack = async () => {
        await this.props.insuranceCalculatorStore.clearFullReport()
        window.history.back()
    }

    render() {
        const {
            filteredMainInsuranceCases,
            sets,
            drugs,
            mainInsuranceCases,
            fitleredMainInsuranceCasesShaban,
            shaban = {},
            hmoCompanies,
            hmoPrices,
            shabanComparisons
        } = this.state

        const title = this.props.computedMatch.params.id
            ? `פירוט דוח כפל חסר של בקשה מספר ${this.props.computedMatch.params.id}`
            : `פירוט דוח כפל חסר של לקוח מספר ${this.props.location.search.split('=').pop()}`

        return (
            <Layout>
                <PageHeader onBack={() => this.goBack()} title="כפל חסר" subTitle={title} />
                <div className="clarification">
                    <h5>מה יש לי וכמה זה עולה לי - חודשי</h5>
                    <InsurancesTable
                        sets={sets}
                        drug={drugs}
                        mainInsuranceCases={mainInsuranceCases}
                        hmoCompanies={hmoCompanies}
                    />
                    {Object.keys(shaban).length ? (
                        <>
                            <h5>השוואה בין תוכנית השב"ן שלכם לתוכניות השב"ן האחרות</h5>
                            <ShabanTable
                                sets={sets}
                                drug={drugs}
                                shaban={shaban}
                                fitleredMainInsuranceCasesShaban={fitleredMainInsuranceCasesShaban}
                                hmoCompanies={hmoCompanies}
                                hmoPrices={hmoPrices}
                                shabanComparisons={shabanComparisons}
                            />
                        </>
                    ) : null}
                    {filteredMainInsuranceCases.length ? (
                        <>
                            <h5>הכיסויים הכפולים שלך וההבדלים ביניהם</h5>
                            <DuplicatesTable
                                sets={sets}
                                drug={drugs}
                                filteredMainInsuranceCases={filteredMainInsuranceCases}
                                hmoCompanies={hmoCompanies}
                            />
                        </>
                    ) : null}
                    <h5>איזה ביטוחים או כיסויים חסרים לי והיכן ניתן לרכוש</h5>
                    <MissingTable sets={sets} drug={drugs} hmoCompanies={hmoCompanies} />
                    {fitleredMainInsuranceCasesShaban.length ? (
                        <>
                            <h5>הכיסויים החופפים שלי</h5>
                            <OverlapsTable
                                sets={sets}
                                drug={drugs}
                                fitleredMainInsuranceCasesShaban={fitleredMainInsuranceCasesShaban}
                                hmoCompanies={hmoCompanies}
                            />
                        </>
                    ) : null}
                    <Clarification />
                </div>
            </Layout>
        )
    }
}
